import React, {useState} from "react";
import {classNames} from "@utils/class-names";
import {ReactComponent as LinkIcon} from "@assets/icons/link.svg";
import {getYouTubeThumbnail} from "@utils/get-youtube-thumbnail";

interface YouTubeThumbnailProps {
    url?: string;
    onOpen?: (e: React.MouseEvent<HTMLElement>) => void;
    className?: string;
}

const YouTubeThumbnail: React.FC<YouTubeThumbnailProps> = ({url, onOpen, className}) => {
    const thumbnailUrl = getYouTubeThumbnail(url);
    const [hasError, setHasError] = useState(false);

    const interactive = Boolean(onOpen);
    const showPlaceholder = !thumbnailUrl || hasError;

    const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
        if (e.currentTarget.naturalWidth <= 120) {
            setHasError(true);
        }
    };

    return (
        <button
            type="button"
            onClick={onOpen}
            disabled={!interactive}
            aria-label={interactive ? "Podejrzyj ćwiczenie w nowej karcie" : undefined}
            className={classNames(
                "group/thumb relative shrink-0 overflow-hidden rounded-lg",
                "bg-input-background/10",
                interactive ? "cursor-pointer" : "cursor-default",
                className
            )}
        >
            {showPlaceholder ? (
                <div className="flex h-full w-full items-center justify-center bg-on-surface/5">
                    <svg className="w-5 h-5 text-on-surface/40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="2.5"/>
                        <circle cx="8.5" cy="8.5" r="1.5"/>
                        <path d="m21 15-5-5L5 21"/>
                    </svg>
                </div>
            ) : (
                <>
                    <img
                        src={thumbnailUrl}
                        alt=""
                        loading="lazy"
                        className="h-full w-full object-cover"
                        onLoad={handleImageLoad}
                        onError={() => setHasError(true)}
                    />
                    {interactive && (
                        <div
                            className={classNames(
                                "absolute inset-0 flex items-center justify-center",
                                "bg-black/50 opacity-0 group-hover/thumb:opacity-100",
                                "transition-opacity duration-150"
                            )}
                        >
                            <LinkIcon className="w-4 h-4 text-white"/>
                        </div>
                    )}
                </>
            )}
        </button>
    );
};

export default YouTubeThumbnail;
